<template>
<main>
  <header>
    <h3>{{visa.Name || '--'}}</h3>
    <p><span>出行日期</span><b class="bold">{{submit.day | format}}</b></p>
    <p><span>购买数量</span><b>{{ submit.count || '-' }}份</b></p>
  </header>
  <section class="contact">
    <h4><span>联系人</span><i class="icon-shouqi-copy"></i></h4>
    <figure>
      <label for="tel" class="max">
        <span>手机号：</span>
        <input v-model="order.contacts_phone" maxlength="11" type="tel" id="tel" @change="loadPhoneInfo"/>
      </label>
      <label for="name" class="max">
        <span>姓名：</span>
        <input v-model="order.contacts_name" type="text" id="name"/>
      </label>
      <label class="max" for="clique">
        <span>公司名称：</span>
        <input v-model="order.company_name" type="text" id="clique"/>
      </label>
      <label class="max" for="clique_name">
        <span>公司地址：</span>
        <input v-model="order.customer_address" type="text" id="clique_name"/>
      </label>
      <label for="recommend">
        <span>推荐人：</span>
        <input v-model="order.referrer" type="text" id="recommend"/>
      </label>
      <label class="select" for="order">
        <span>订单来源：</span>
        <b>{{sourceName}}</b>
        <select id="order" @change="changeSource">
          <option :value="v.id" v-for="(v) in deploy.orderSource" :key="v.id">{{v.name}}</option>
        </select>
      </label>
      <label for="order_no">
        <span>第三方单号：</span>
        <input v-model="order.source_number" type="text" id="order_no"/>
      </label>
      <label for="remark">
        <span>备注：</span>
        <input v-model="order.remark" type="text" id="remark"/>
      </label>
    </figure>
  </section>
  <section class="mail">
    <h4>
      <span>签证邮寄</span>
      <b class="switch" @click="deploy.express = !deploy.express" :class="{on: deploy.express }"></b>
    </h4>
    <div 
      class="addr" 
      :class="{ on: deploy.express }"
      @click="selectAddress('express')">
      <figure>
        <i class="icon-address_icon"></i>
        <div>
          <p v-if="!!order.express"><b>{{order.express.addressee}}</b><span>({{order.express.phone}})</span></p>
          <p>{{ order.express | getAddress }}</p>
        </div>
      </figure>
      <i class="icon-you"></i>
    </div>
  </section>
  <section class="mail">
    <h4>
      <span>签证回寄</span>
      <b class="switch" @click="deploy.post = !deploy.post" :class="{on: deploy.post}"></b>
    </h4>
    <div 
      class="addr" 
      :class="{ on: deploy.post }"
      @click="selectAddress('post')">
      <figure>
        <i class="icon-address_icon"></i>
        <div>
          <p v-if="!!order.post"><b>{{order.post.addressee}}</b><span>({{order.post.phone}})</span></p>
          <p>{{ order.post | getAddress }}</p>
        </div>
      </figure>
      <i class="icon-you"></i>
    </div>
  </section>
  <router-link tag="section" :to="{name: 'visa_otherPrice'}" class="other">
    <h4>
      <span>其他费用</span>
      <i class="icon-you"></i>
    </h4>
  </router-link>
  <section class="info">
    <h4><span>费用明细(¥)</span></h4>
    <ul>
      <li><span>签证费用：</span><b>{{ visaPrice }}</b></li>
      <li><span>签证邮寄：</span><b>{{ price.express }}</b></li>
      <li><span>签证回寄：</span><b>{{ price.post }}</b></li>
      <li><span>其他费用：</span><b>{{ price.other }}</b></li>
    </ul>
  </section>
  <footer>
    <div class="detail">
      <span>合计：</span>
      <b>{{price.total}}</b>
    </div>
    <button class="next" @click="save">提交订单</button>
  </footer>
</main>
</template>

<script>
import moment from 'moment';
import $visa from '@api/visa';
import $check from '@assets/js/check';
export default {
  data () {
    return {
      info: {},
      submit: {},
      // 订单信息
      order: {
        contacts_phone: null,
        contacts_name: null,
        company_name: null,
        customer_address: null,
        referrer: null,
        source_number: null,
        remark: null,
        sourceIndex: null,
        express: null,
        post: null,
        otherPrice: []
      },
      deploy: {
        mailType: null,
        express: false, // 签证邮寄
        post: false, // 签证回寄
        orderSource: [
          { name: 'B2C', id: 0 },
          { name: 'B2B', id: 1 },
          { name: '微商城', id: 2 },
          { name: '天猫', id: 3 },
          { name: '去哪儿', id: 4 },
          { name: '携程', id: 5 },
          { name: '内部下单', id: 6 },
          { name: '百国旅行', id: 7 },
          { name: '第三方', id: 8 }
        ],
      }
    }
  },
  computed: {
    sourceName () {
      const { sourceIndex } = this.order;
      const { orderSource } = this.deploy;
      return sourceIndex !== null ? orderSource[sourceIndex].name : '请选择';
    },
    visa () {
      const { visa_prices } = this.info;
      const { meal } = this.submit;
      return visa_prices[meal];
    },
    user () {
      return this.getUserInfo();
    },
    getPriceAttr () {
      const { priceAttr } = this.$route.query;
      return priceAttr || this.getPriceName();
    },
    visaPrice () {
      const { visa_prices } = this.info;
      const { meal, count } = this.submit;
      const visa = visa_prices[meal];
      const attr = this.getPriceAttr;
      return parseFloat((Number(visa[attr]) * count).toFixed(2));
    },
    price () {
      const { otherPrice} = this.order;
      const other = otherPrice.reduce((t, v) => {
        t += (v.unit_price || 0) * v.count;
        return t;
      }, 0);
      let express = this.order.express ? (this.order.express.province === '广东省' ? 13 : 23) : 0;
      express = this.deploy.express ? express : 0;
      let post = this.order.post ? (this.order.post.province === '广东省' ? 13 : 23) : 0;
      post = this.deploy.post ? post : 0;
      const total = parseFloat((this.visaPrice + other + express + post).toFixed(2));
      return {
        other: parseFloat(other.toFixed(2)),
        express,
        post,
        total
      }
    }
  },
  filters: {
    format (val, desc = 'YYYY年MM月DD日') {
      return val ? moment(val).format(desc) : '请选择';
    },
    getAddress (v) {
      if ( !v ) { return '请选择'; }
      const { province, city, district, address } = v;
      return province+city+district+address;
    }
  },
  created () {
    const info = JSON.parse(sessionStorage.getItem('visaInfo') || 'null');
    const submit = JSON.parse(sessionStorage.getItem('visaData') || 'null');
    if ( !info || !submit ) { this.$router.push({ name: 'home' }); return; }
    this.info = info;
    this.submit = submit;
  },
  activated () {
    // 截取地址
    const { mailType } = this.deploy;
    const address = JSON.parse(sessionStorage.getItem('SelectedAddr') || 'null');
    if ( mailType && address ) {
      this.order = { ...this.order, [mailType]: address };
      sessionStorage.removeItem('SelectedAddr');
    }
    // 截取其他费用
    const otherPrice = JSON.parse(sessionStorage.getItem('otherPrice') || 'null');
    if ( otherPrice ) {
      this.order = { ...this.order, otherPrice };
      sessionStorage.removeItem('otherPrice');
    }
  },
  methods: {
    checkSaveData () {
      const { contacts_phone, contacts_name } = this.order;
      if ( $check.isPhone(contacts_phone) === false || Boolean(contacts_name) === false ) {
        this.$toast('联系人手机号或姓名不能为空！');
        return false;
      }
      return true;
    },
    getSaveData () {
      const {
        contacts_phone: Moblie,
        contacts_name: CustomerName,
        company_name, customer_address, referrer, source_number, remark,
        sourceIndex,
        express,
        post,
        otherPrice
      } = this.order;
      const { day: UserDateTime, count: quantity } = this.submit;
      const { total: visaAmount, express: express_data_amount, post: post_back_amount } = this.price;
      const { 
        VisaProductID: ProductID, 
        Name: ProductName, 
        FormName, KindName,
      } = this.info;
      const { Id: VisaPriceId, Name: VisaPriceName, } = this.visa;
      let data = {
        // 联系人信息
        Moblie, CustomerName, company_name, customer_address, referrer, source_number, remark,
        ProductID, ProductName, FormName, KindName,
        order_source: sourceIndex !== null ? this.deploy.orderSource[sourceIndex].id : '', // 订单来源
        UserDateTime, // 出行日期
        visaAmount, // 签证订单金额
        priceName: this.getPriceAttr,
        // 保险模块（暂无）
        InsAmount: 0,
        // 其他费用
        otherFees: otherPrice.map(v => {
          const res = {
            fees_class_id: v.item,
            quantity: v.count,
            remark: v.remark,
            unit_price: v.unit_price
          }
          return res;
        }),
        // 签证套餐信息
        visaOrderPackage: {
          VisaPriceId,
          VisaPriceName,
          unitPrice: this.visa[this.getPriceAttr],
          quantity,
          amount: visaAmount
        },
        // 邮寄信息
        express_data_amount,
        post_back_amount,
        is_express_data: express ? express.id : null,
        is_post_back: post ? post.id : null,
      };
      return data;
    },
    async save () {
      if ( this.checkSaveData() === false ) { return; }
      const data = this.getSaveData();
      const { OK } = await $visa.addOrder(data);
      sessionStorage.removeItem('visaInfo');
      sessionStorage.removeItem('visaData');
      this.$router.push({ name: 'pay', query: { orderNo: OK, type: 'visa' } });
    },
    async loadPhoneInfo () {
      const { contacts_phone } = this.order;
      if ( !$check.isPhone(contacts_phone) ) { return; }
      const { CustomerName, company_name, customer_address } = await $visa.getCustomerByphone(contacts_phone);
      this.order = { 
        ...this.order,
        contacts_name: CustomerName,
        company_name,
        customer_address
      }
    },
    selectAddress (type) {
      this.deploy = { ...this.deploy, mailType: type };
      this.$router.push({ name: 'address', query: { type: 'select' } });
    },
    changeOrder (val, attr) {
      this.order = { ...this.order, [attr]: val };
    },
    changeSource (e) {
      const { value } = e.target;
      this.changeOrder(Number(value), 'sourceIndex');
    }
  }
}
</script>

<style scoped src="./created.css"></style>